import React from 'react';
import { ListItem, Menu } from '../DefaultMenu/styles';
import { NavLink } from 'react-router-dom';
import coinIcon from 'assets/images/coinIcon.svg';

const MenuSeturFundetur: React.FC = () => {
  return (
    <Menu>
      <ul>
        <ListItem>
          <NavLink activeClassName="selected" to="/">
            <img src={coinIcon} alt="icon for list item" />
            <span>Fundo do Turismo</span>
          </NavLink>
        </ListItem>
      </ul>
    </Menu>
  );
};

export default MenuSeturFundetur;
